import { render, staticRenderFns } from "./ProposalSidebar.vue?vue&type=template&id=3bb05fec"
import script from "./ProposalSidebar.vue?vue&type=script&lang=js"
export * from "./ProposalSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports